@if (!isIframeReceivedAllNecessaryData) {
    <sb-loader></sb-loader>
}

<div class="iframe" [ngClass]="{ 'd-none': !isIframeReceivedAllNecessaryData }">
    <iframe class="iframe-object" #appIFrame (load)="loadIframe(appIFrame)" [src]="currentApp?.safeInboxUrl"> </iframe>
</div>
